<template>
<div class="subprogram-nba-standings-page">
  <!-- Actions buttons only in standings tab -->
  <div class="subprogram-nba-standings-page__button">
    <!-- Division button -->
    <el-button
      :class="showDivision === false ? 'subprogram-nba-standings-page__button__division is-disabled' : 'subprogram-nba-standings-page__button__division'"
      @click="showInfoDivision"
    >
      <app-i18n code="entities.subprogram.nba.team.standings.division"></app-i18n>
    </el-button>
    <!-- Conference button -->
    <el-button
      :class="showConference === false ? 'subprogram-nba-standings-page__button__conference is-disabled' : 'subprogram-nba-standings-page__button__conference'"
      @click="showInfoConference"
    >
      <app-i18n code="entities.subprogram.nba.team.standings.conference"></app-i18n>
    </el-button>
  </div>

  <div class="subprogram-nba-standings-page__container" v-loading="loading">
    <div class="subprogram-nba-standings-page__container__teams" v-for="(conference, i) in conferences" :key="i">
      <span
        class="subprogram-nba-standings-page__container__teams__title"
        v-text="conference.title"
      />
      <!-- Conference table -->
       <app-subprogram-nba-standings-table
          v-if="showConference"
          :teams="Object.values(conference.teams)"
          :onRowClick="onRowClick"
          :title="i18n('entities.subprogram.nba.team.standings.fields.teams')"
          :isConference="showConference"
        />
      <div v-else>
        <div v-for="(division, i) in conference.divisions" :key="i">
          <!-- Division table -->
          <app-subprogram-nba-standings-table
            :teams="Object.values(division.teams)"
            :onRowClick="onRowClick"
            :title="division.title"
          />
        </div>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import SubprogramNbaStandingsTable from '@modules/subprogram/nba/components/subprogram-nba-standings-table.vue';
import { mapGetters, mapActions } from 'vuex';
import { get } from 'lodash';
import { i18n } from '@shared/i18n';

export default {
    name: 'app-subprogram-nba-standings-page',

    components: {
      [SubprogramNbaStandingsTable.name]: SubprogramNbaStandingsTable
    },

    data() {
      return {
        showConference: false,
        showDivision: true,
      }
    },
  
    computed: {
    ...mapGetters({
      conferences: 'subprogram/nba/standings/conferences',
      loading: 'subprogram/nba/standings/loading',
      currentManage: 'auth/manage/currentManage',
    }),

    subpropertyId() {
      return get(this, 'currentManage.subproperty.id', null);
    },
  },

  async mounted () {
    const { subprogramId } = this.$route.params;
    await this.doLoad({ subpropertyId: this.subpropertyId, subprogramId});
  },

  methods: {
    ...mapActions({
      doLoad: 'subprogram/nba/standings/doLoad',
    }),
    showInfoDivision() {
      this.showDivision = true;
      this.showConference = false;
    },
    showInfoConference() {
      this.showDivision = false;
      this.showConference = true;
    },
    i18n(code) {
      return i18n(code);
    },
    onRowClick(row, column) {
      if (!('label' in column)) return;
      if (row.isMatched === true) {
        console.log({
            programId: row.program.id,
            subprogramId: row.subprogram.id,
            teamId: row.id
          })
        this.$router.push({
          name: 'SubprogramNbaSchoolTeamView',
          params: {
            programId: row.program.id,
            subprogramId: row.subprogram.id,
            teamId: row.id,
            tabName: 'summary',
          }
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.subprogram-nba-standings-page {
  &__button {
    margin-top: -50px;
    display: grid;
    grid-template-areas: 'conference division';
    justify-content: right;

    &__conference {
      margin: 0;
      border: none;
      border-radius: 0px !important;
      border-top-right-radius: 25px !important;
      border-bottom-right-radius: 25px !important;
      &.is-disabled {
        color: #c5c5c5;
        background-color: #ececec;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        cursor: pointer;
      }
      &:focus, &:hover {
        background-color: #ffffff;
        color: #404040;
      }
    }
    &__division {
      margin: 0;
      border: none;
      border-radius: 0px !important;
      border-top-left-radius: 25px !important;
      border-bottom-left-radius: 25px !important;
      &.is-disabled {
        color: #c5c5c5;
        background-color: #ececec;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        cursor: pointer;
      }
      &:focus, &:hover {
        background-color: #ffffff;
        color: #404040;
      }
    }
  }

  &__container {
    margin-top: 24px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    &__teams {
      padding: 40px 64px;
      &__title {
        font-size: 18px;
        color: #4c4c4c;
        text-transform: uppercase;
      }
    }
  }
}
</style>
<style>
.subprogram-nba-standings-page .el-table:not(.el-table--simple) td:last-of-type .cell {
  padding: 0 30px;
}

.subprogram-nba-standings-page .el-table__row {
  cursor: default;
}

.subprogram-nba-standings-page__container__teams__table__label {
  text-transform: uppercase;
}
</style>